"use client";

import type { LucideIcon } from "lucide-react";

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  subtitle?: string;
}

export const CatalogEmptyState = ({ icon: Icon, title, subtitle }: EmptyStateProps) => {
  return (
    <div className="anim-pop border-muted flex flex-col items-center justify-center rounded-xl border border-dashed py-16">
      <Icon size={36} className="text-foreground/15 mb-3" />
      <p className="text-foreground/40 text-sm font-medium">{title}</p>
      {subtitle && <p className="text-foreground/30 mt-1 text-xs">{subtitle}</p>}
    </div>
  );
};
